var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensolitePasarelas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1149.51 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b8b8b7;}.cls-2{isolation:isolate;}.cls-3{fill:#e2e2e2;mix-blend-mode:multiply;}.cls-4{clip-path:url(#clippath);}.cls-5{fill:none;}.cls-6{fill:#9c9b9b;}.cls-7{fill:#c4c4c4;}.cls-8{fill:#e9e9ea;}.cls-9{fill:#dfdfdf;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 563.17,
    cy: 539.93,
    r: 420.42
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 563.17,
    cy: 540.9,
    r: 420.42
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "530.69 288.6 966.43 176.2 944.96 161.95 509.22 274.35 530.69 288.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "94.89 672.31 530.69 288.63 509.88 275.84 74.09 659.53 94.89 672.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "923.58 209.66 902.73 215.04 902.73 222.7 923.58 235.69 923.58 209.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "94.89 672.31 73.42 658.04 73.42 719.63 94.95 733.1 94.89 672.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "923.58 235.69 902.73 222.7 140.63 654.6 140.63 679.74 923.58 235.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.95,731.03L966.43,238.85v-62.58l-435.74,112.4v-.07L94.95,671.77v.5l-.05,.04,.05,58.72ZM668.9,380.14l-130.42,73.97v-145.1l130.42-33.64v104.78Zm15.57-108.79l129.24-33.34v60.01l-129.24,73.29v-99.96Zm-161.56,191.59l-129.47,73.43v-104.73l129.47-113.85v145.15Zm-145.04,82.26l-128.86,73.08v-59.63l128.86-113.31v99.87Zm-144.43,81.91l-92.8,52.63v-25.8l92.8-81.6v54.77ZM923.58,235.69l-94.31,53.49v-55.19l94.31-24.33v26.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "813.7 237.97 792.85 243.35 792.85 285 813.7 298 813.7 238.1 813.7 237.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "668.9 275.36 648.04 280.74 648.04 367.11 668.9 380.1 668.9 275.49 668.9 275.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "522.9 317.47 502.05 336.12 502.05 449.79 522.9 462.78 522.9 317.61 522.9 317.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "377.86 445.4 357.01 463.66 357.01 532.18 377.86 545.17 377.86 445.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "233.43 572.33 212.58 590.67 212.58 614.11 233.43 627.11 233.43 572.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "713.77 419.75 1149.51 307.35 1128.04 293.1 692.3 405.5 713.77 419.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "277.98 803.46 713.77 419.78 692.3 405.53 256.5 791.64 277.98 803.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1086.66 342.81 1065.81 348.19 1065.81 355.85 1086.66 368.84 1086.66 342.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "277.98 803.46 256.5 791.64 256.5 850.78 278.03 864.25 277.98 803.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1106.66 366.84 1085.81 353.85 323.72 785.75 323.72 810.89 1106.66 366.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.98,860.39l.05-.03v3.89l871.48-494.25v-62.58l-435.74,112.4v-.07l-435.74,383.17v.5l-.05,.04v56.93ZM851.98,511.29l-130.42,73.97v-145.1l130.42-33.64v104.78Zm15.57-108.79l129.24-33.34v60.01l-129.24,73.29v-99.96Zm-161.56,191.59l-129.47,73.43v-104.73l129.47-113.85v145.15Zm-145.04,82.26l-128.86,73.08v-59.63l128.86-113.31v99.87Zm-144.43,81.91l-92.8,52.63v-25.8l92.8-81.6v54.77Zm690.15-391.41l-94.31,53.49v-55.19l94.31-24.33v26.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "996.79 369.12 975.93 374.5 975.93 416.15 996.79 429.15 996.79 369.26 996.79 369.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "851.98 406.51 831.13 411.89 831.13 498.26 851.98 511.26 851.98 406.64 851.98 406.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "705.99 448.62 685.13 467.27 685.13 580.94 705.99 593.93 705.99 448.76 705.99 448.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "560.95 576.55 540.1 594.81 540.1 663.33 560.95 676.32 560.95 576.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "416.52 703.48 395.67 721.82 395.67 745.26 416.52 758.26 416.52 703.48"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.65,279.21L75.32,657.89c-.93,.82-.76,2.31,.33,2.91l18.14,9.95c.66,.36,1.48,.27,2.04-.23L505.02,310.26c.39-.34,.61-.83,.61-1.34v-28.37c0-1.54-1.82-2.36-2.97-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.97,670.84l-17.9-9.81c-1.19-.65-2.65,.21-2.65,1.57v55c0,.66,.37,1.27,.95,1.58l17.95,9.5c1.19,.63,2.63-.23,2.62-1.58l-.05-54.69c0-.65-.36-1.25-.93-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M491.91,454.55l-350.37,198.57c-.56,.32-.91,.91-.91,1.56v21.02c0,1.37,1.48,2.23,2.67,1.56l360.63-204.53c.91-.52,1.18-1.7,.6-2.56l-10.26-15.06c-.52-.77-1.55-1.01-2.36-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.63,498.18v-23.34c0-1.37-1.48-2.23-2.67-1.56l-106.85,60.6c-1.19,.68-2.67-.18-2.67-1.56v-100.85c0-.51,.22-1,.61-1.34l110.98-97.59c.39-.34,.61-.83,.61-1.34v-17.58c0-1.54-1.81-2.36-2.97-1.34L94.95,671.3h0l-.05,.04v56.93l.05-.03v1.82l409.77-230.33c.56-.32,.91-.91,.91-1.56Zm-256.02,58.97l125.29-110.17c1.16-1.02,2.97-.2,2.97,1.34v94.87c0,.64-.35,1.24-.91,1.56l-125.29,71.05c-1.19,.68-2.67-.18-2.67-1.56v-55.75c0-.51,.22-1,.61-1.34Zm-108.37,95.29l89.22-78.46c1.16-1.02,2.97-.2,2.97,1.34v49.78c0,.64-.35,1.24-.91,1.56l-89.22,50.6c-1.19,.68-2.67-.18-2.67-1.56v-21.92c0-.51,.22-1,.61-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M516.94,321.85h0c-.38,.34-.6,.82-.6,1.33v111.87c0,.62,.32,1.19,.84,1.52h0c1.19,.74,2.73-.11,2.73-1.52v-111.87c0-1.55-1.83-2.36-2.98-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.9,447.03l-17.28,15.13c-.39,.34-.61,.83-.61,1.35v66.71c0,.62,.32,1.19,.84,1.52l17.28,10.77c1.19,.74,2.73-.11,2.73-1.52v-92.6c0-1.54-1.81-2.36-2.97-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.46,573.98l-17.28,15.19c-.39,.34-.61,.83-.61,1.34v21.64c0,.62,.32,1.19,.84,1.52l17.28,10.77c1.19,.74,2.73-.11,2.73-1.52v-47.6c0-1.54-1.81-2.36-2.97-1.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M547.26,532.29l-288.86,256.71c-.92,.82-.76,2.31,.33,2.9l18.15,9.99c.66,.36,1.48,.27,2.04-.22l270.71-238.34c.39-.34,.61-.83,.61-1.34v-28.36c0-1.54-1.82-2.36-2.98-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.05,801.99l-17.9-9.85c-1.19-.66-2.65,.21-2.65,1.57v56.76c0,.65,.36,1.26,.93,1.57l17.95,9.81c1.19,.65,2.65-.21,2.65-1.57l-.05-56.72c0-.65-.36-1.25-.93-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M532.07,666.71l-207.45,117.57c-.56,.32-.91,.91-.91,1.56v21.02c0,1.37,1.48,2.23,2.67,1.56l221.69-125.73c1.06-.6,1.22-2.07,.32-2.88l-14.24-12.86c-.57-.52-1.41-.61-2.08-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.23,707.87v-23.34c0-1.37-1.48-2.23-2.67-1.56l-112.81,63.98c-1.19,.68-2.67-.18-2.67-1.56v-55.75c0-.51,.22-1,.61-1.34l116.93-102.83c.39-.34,.61-.83,.61-1.34v-17.58c0-1.54-1.81-2.36-2.97-1.34l-269.23,236.75v.5l-.05,.04v60.76l.05,.03,271.3-153.86c.56-.32,.91-.91,.91-1.56Zm-225.91,75.72l89.22-78.46c1.16-1.02,2.97-.2,2.97,1.34v49.78c0,.64-.35,1.24-.91,1.56l-89.22,50.6c-1.19,.68-2.67-.18-2.67-1.56v-21.92c0-.51,.22-1,.61-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M547.27,587.57l-6.56,5.75c-.39,.34-.61,.83-.61,1.35v66.71c0,.62,.32,1.19,.84,1.52l6.56,4.09c1.19,.74,2.73-.11,2.73-1.52v-76.55c0-1.54-1.81-2.36-2.97-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M413.55,705.13l-17.28,15.19c-.39,.34-.61,.83-.61,1.34v21.64c0,.62,.32,1.19,.84,1.52l17.28,10.77c1.19,.74,2.73-.11,2.73-1.52v-47.6c0-1.54-1.81-2.36-2.97-1.34Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 1080,
    height: 1080,
    rx: 1.79,
    ry: 1.79
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensolitePasarelas);
export default __webpack_public_path__ + "static/media/Tensolite Pasarelas.e61bb8e5d327d167dfcda0d310145303.svg";
export { ForwardRef as ReactComponent };